import React, { useEffect, useState } from 'react';
import { Provider } from '../../../app/models/Provider';
import useHandleErrorFields from '../../../hooks/useHandleErrorFields';
import useRut from '../../../hooks/useRut';
import SelectTwo, { SelectTwoMapperOptions } from '../../../components/SelectTwo';
import { Society } from '../../../app/models/Society';
import { SocietyProviderDataForm } from '../../../app/models/SocietyProvider';
import { ProviderContact } from '../../../app/models/ProviderContact';
import LazyLoading from '../../../components/LazyLoading';
type Props = {
    societyProviderForm: SocietyProviderDataForm;
    setSocietyProviderForm: (societyproviderForm: SocietyProviderDataForm) => void;   
    societies: Society[];
    providers: Provider[];
    errorFields?: any;
    providerTypes?: any[];
    nextId?: number; 
    providerContacts: ProviderContact[];
    loadingProviderContact: boolean;
    isEdit?: boolean;
};

const ProviderForm = (
    { 
        societyProviderForm, 
        setSocietyProviderForm,
        providerTypes, 
        societies, 
        providers, 
        errorFields, 
        providerContacts,
        loadingProviderContact, 
        nextId = 0, 
        isEdit }
    : Props) => {

    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    const { formatRut } = useRut();
    const [tempRut, setTempRut] = useState<string | null>(null);

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
    
        if (name === "rut") {
            setSocietyProviderForm({ ...societyProviderForm, rut: formatRut(value) });
        } else {
            setSocietyProviderForm({ ...societyProviderForm, [name]: value });
        }
    };
  

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {

        const obj = { [name]: value };
        
        if(name === 'provider_id'){
            const selectedProvider: any = providers.find(
                (p) => p.id === value
            );
       
            if (selectedProvider) {
              
                obj.rut = selectedProvider.rut ?? '';
                obj.name = selectedProvider.name ?? '';
                obj.email = selectedProvider.email ?? '';
                obj.phone_code = selectedProvider.phone_code ?? '';
                obj.phone = selectedProvider.phone ?? '';
                obj.address = selectedProvider.address ?? '';
                obj.is_national = selectedProvider.is_national ?? undefined;
            }
        }
      
        setSocietyProviderForm({ ...societyProviderForm, ...obj });

    };

    const [image, setImage] = useState(
        societyProviderForm.logo
            ? societyProviderForm.logo
            : 'https://static.vecteezy.com/system/resources/previews/009/292/244/original/default-avatar-icon-of-social-media-user-vector.jpg'
    );

    return (
        <>
                        <div className="col-md-12 text-center d-flex">
                            <div className="mx-auto mb-3">
                                <label htmlFor="logo">
                                    <img
                                        src={
                                            typeof image === 'string' && image !== ''
                                                ? image
                                                : window.URL.createObjectURL(image as Blob)
                                        }
                                        className="rounded-circle pointer bg-white"
                                        style={{
                                            width: '150px',
                                            height: '150px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </label>
                            </div>
                        </div>

                        <div className="mb-2 col-md-12">
                        <label className="col-form-label">Sociedad</label>
                        <SelectTwo
                            name="society_id"
                            id="society_id"
                            inputValue={societyProviderForm.society_id}
                            options={SelectTwoMapperOptions(societies)}
                            hasError={fieldHasError('society_id') !== ''}
                            onChange={(value: any) => handleChangeSelectTwo('society_id', value.value)}
                            placeholder="Seleccione una sociedad"
                            onFocus={() => onFocusRemove('society_id')}
                        />
                        <div className="invalid-feedback" style={{ display: 'flex' }}>
                            {fieldErrorMessage('society_id')}
                        </div>
                    </div>
                        <div className="mb-2 col-md-12">
                            <label className="col-form-label">Proveedor</label>
                            <SelectTwo
                                name="provider_id"
                                id="provider_id"
                                // inputValue={Provider.provider_id}
                                inputValue={societyProviderForm.provider_id}
                                options={SelectTwoMapperOptions(providers)}
                                hasError={fieldHasError('society_id') !== ''}
                                onChange={(value: any) => handleChangeSelectTwo('provider_id', value.value)}
                                placeholder="Seleccione una sociedad"
                                onFocus={() => onFocusRemove('provider_id')}
                                // disabled={disableUpdate}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('provider_id')}
                            </div>
                        </div>

                        {/* <div className="mb-2 row">
                            <label className="col-form-label">N° cuenta corriente</label>
                            <div className="col-md-12">
                                <input
                                    name="account_number"
                                    id="account_number"
                                    type="text"
                                    className={`form-control ${fieldHasError('account_number')}`}
                                    // value={Provider.account_number}
                                    value={societyProviderForm.account_number}
                                    onChange={handleChange}
                                    onFocus={() => onFocusRemove('account_number')}
                                    placeholder="Ingrese n° de cuenta"
                                    readOnly={true}
                                />
                                <div className="invalid-feedback" style={{ display: 'flex' }}>
                                    {fieldErrorMessage('account_number')}
                                </div>
                            </div>
                        </div> */}

                        <div className="mb-2 row needs-validation">
                            <label className="col-form-label">Origen</label>
                            <div className="col-md-12">
                                <input
                                    name="is_national"
                                    id="is_national"
                                    type="text"
                                    className={`form-control ${fieldHasError('is_national')}`}
                                    value={
                                        societyProviderForm.is_national === undefined || societyProviderForm.is_national === null
                                            ? ''
                                            : societyProviderForm.is_national
                                            ? 'Nacional'
                                            : 'Extranjero'
                                    }
                                    readOnly={true}
                                />
                             </div>
                        </div>


                    <div className="mb-2 row needs-validation">
                        <label className="col-form-label">Nombre</label>
                        <div className="col-md-12">
                            <input
                                name="name"
                                id="name"
                                type="text"
                                className={`form-control ${fieldHasError('name')}`}
                                value={societyProviderForm.name}
                                onChange={handleChange}
                                onFocus={() => onFocusRemove('name')}
                                // placeholder="Ingrese el nombre del proveedor"
                                readOnly={true}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('name')}
                            </div>
                        </div>
                    </div>

                        <div className="mb-2 row">
                            <label className="col-form-label">Rut</label>
                            <div className="col-md-12">
                                <input
                                    name="rut"
                                    id="rut"
                                    type="text"
                                    className="form-control"
                                    value={societyProviderForm.rut || ''}
                                    onChange={handleChange}
                                    onFocus={() => onFocusRemove('rut')}
                                    // placeholder="Ingrese el RUT del proveedor"
                                    readOnly={true}
                                />
                                <div className="invalid-feedback" style={{ display: 'flex' }}>
                                    {fieldErrorMessage('rut')}
                                </div>
                            </div>
                        </div>

            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Email</label>
                    <input
                        name="email"
                        id="email"
                        type="text"
                        className="form-control"
                        value={societyProviderForm.email}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('email')}
                        // placeholder="Ingrese email"
                        readOnly={true}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('email')}
                    </div>
                </div>               
            </div>
            <div className='mb-2 row"'>
                <div className="col-md-12">
                    <label className="col-form-label">Dirección</label>
                    <input
                        name="address"
                        id="address"
                        type="text"
                        className="form-control"
                        value={societyProviderForm.address}
                        onChange={handleChange}
                        onFocus={() => onFocusRemove('address')}
                        // placeholder="Ingrese domicilio"
                        readOnly={true}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('address')}
                    </div>
                </div>               
            </div>
            <div className='mb-2 row'>
                <div className="col-md-12">
                    <label className=" col-form-label">Teléfono</label>
                    <div className="row">
                        <div className="col-auto">
                            <select
                                className="form-control form-control-custom pl-2"
                                id="phone_code"
                                name="phone_code"
                                onChange={handleChange}
                                value={societyProviderForm.phone_code}
                                onFocus={() => onFocusRemove('phone_code')}
                                disabled={true}
                            >
                                <option value="">--</option>
                                <option value="+56">+56</option>
                            </select>
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('phone_code')}
                            </div>
                        </div>

                        <div className="col">
                            <input
                                name="phone"
                                id="phone"
                                type="text"
                                className="form-control"
                                value={societyProviderForm.phone}
                                onChange={handleChange}
                                onFocus={() => onFocusRemove('phone')}
                                placeholder="Teléfono"
                                readOnly={true}
                            />
                            <div className="invalid-feedback" style={{ display: 'flex' }}>
                                {fieldErrorMessage('phone')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
{/* 
            {
                loadingProviderContact ?
                <LazyLoading height={300} />
                :
                <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Contacto Proveedor</label>
                    <SelectTwo
                        name="business_name_contact_id"
                        id="business_name_contact_id"
                        inputValue={societyProviderForm.business_name_contact_id}
                        options={SelectTwoMapperOptions(providerContacts, 'id', ['name'])}
                        hasError={fieldHasError('business_name_contact_id') !== ''}
                        onChange={(value: any) =>
                            handleChangeSelectTwo('business_name_contact_id', value?.value)
                        }
                        placeholder={'Seleccione contacto'}
                        onFocus={() => onFocusRemove('business_name_contact_id')}
                        isClearable={true}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('business_name_contact_id')}
                    </div>
                </div>
            </div>
            } */}
        </>
    );
};

export default ProviderForm;
